import React, { useEffect, useState } from 'react'
import {
    Box,
    Tabs,
    Tab,
    Paper,
    Typography,
} from '@mui/material';
import {
    Divider,
    Grid,
    Button,
    Card,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    FormLabel,
    FormControl,
    TextField,
    InputAdornment
} from '@mui/material';
import _ from 'lodash';
import { useForm } from "react-hook-form";

import CustomLayout from 'views/CustomLayout'
import CustomBreadcrumbs from "components/Breadcrumbs";
import axiosInstance from "configs/axiosConfig";

import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Loader from 'components/Loader';
import { APIRouteConstants } from 'constants/routeConstants';
import { useSnackbar } from 'notistack';

const UserSetting = ({ breadcrumbs }) => {
    const [openUpdatePass, setUpdatePass] = useState(false);
    const [activeCard, setActiveCard] = useState();
    const [openUpdateAdd, setUpdateAdd] = useState(false);
    const [userDetail, setUserDetail] = useState({})
    const [loader, setLoader] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const { register, formState: { errors }, handleSubmit, reset } = useForm();

    const getUserDetails = async (category) => {
        setLoader(true)
        let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.GET_USER_DETAIL);
        let { data } = res;

        if (data && !_.isEmpty(data.data)) {
            setUserDetail(data.data)
        }
        setLoader(false)
    }

    const handleUpdatePassword = async (formData) => {
        setLoader(true)
        let res = await axiosInstance.post(APIRouteConstants.DASHBOARD.UPDATE_PASSWORD, formData);
        let { data, response } = res;

        if (response
            && response.status == 400
            && response.data) {
            enqueueSnackbar(response.data.message, { variant: 'error' })
            reset()
        }

        if (!_.isEmpty(data)) {
            enqueueSnackbar('Password updated successfully', { variant: 'success' })
            setUpdatePass(false)
            reset()
        }
        setLoader(false)
    }

    const [addressList, setAddressList] = useState([]);

    const getAddressList = async () => {
        let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.GET_ADDRESS_LIST);
        let { data, response } = res;

        if (response
            && response.status === 400
            && response.data) {
            for (let i in response.data) {
                enqueueSnackbar(_.capitalize(i) + ': ' + response.data[i][0], { variant: 'error' });
                setLoader(false)
            }
        }

        if (data) {
            setAddressList(data);
        }
    }

    useEffect(() => {
        getUserDetails()
        getAddressList()
    }, [])

    return (
        <CustomLayout>
            <Loader open={loader} />
            <div className="content-container">
                <CustomBreadcrumbs list={breadcrumbs} name={_.get(userDetail, 'first_name') + ' ' + _.get(userDetail, 'last_name')} />
                <Divider className="divider" />
                <ContactTabs userDetail={userDetail} />
            </div>
        </CustomLayout>
    )
}

export default UserSetting



function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

const ContactTabs = ({ userDetail }) => {
    const [tabIndex, setTabIndex] = useState(0);

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    console.log("details", userDetail)
    return (
        <Grid elevation={3} sx={{ mt: 2, boxShadow: 2, p: 3 }}>
            <Tabs
                value={tabIndex}
                onChange={handleChange}
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab
                    icon={<ContactEmergencyIcon />}
                    iconPosition="start"
                    label="Account"
                    sx={{ textTransform: 'capitalize' }}
                />
                <Tab
                    icon={<LocationOnIcon />}
                    iconPosition="start"
                    label="Addresses"
                    sx={{ textTransform: 'capitalize' }}
                />
            </Tabs>


            {/* <TabPanel value={tabIndex} index={0}>
                <Grid container spacing={2} >
                    <Grid item xs={6} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary" >
                            First Name
                        </Typography>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{userDetail.first_name}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Last Name
                        </Typography>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{userDetail.last_name}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Email
                        </Typography>
                        <Typography variant="body1">{userDetail.email}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Contact
                        </Typography>
                        <Typography variant="body1">{`+${userDetail.country_code} ${userDetail.mobile_number}`}</Typography>
                    </Grid>
                </Grid>
            </TabPanel> */}
            <TabPanel value={tabIndex} index={0}>
                <Grid container spacing={2}>
                    {/* First Name */}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            First Name
                        </Typography>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
                            {userDetail.first_name}
                        </Typography>
                    </Grid>

                    {/* Last Name */}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Last Name
                        </Typography>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
                            {userDetail.last_name}
                        </Typography>
                    </Grid>

                    {/* Email */}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Email
                        </Typography>
                        <Typography variant="body1">{userDetail.email}</Typography>
                    </Grid>

                    {/* Contact - Country Code & Mobile Number in same row */}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Contact
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body1">+{userDetail.country_code}</Typography>
                            <Typography variant="body1">{userDetail.mobile_number}</Typography>
                        </Box>
                    </Grid>

                </Grid>
            </TabPanel>


            <TabPanel value={tabIndex} index={1}>
                <Typography variant="subtitle1" gutterBottom>No Details available</Typography>
                {/* <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Street
                        </Typography>
                        <Typography variant="body1">{addressInfo.street}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            City
                        </Typography>
                        <Typography variant="body1">{addressInfo.city}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Postal Code
                        </Typography>
                        <Typography variant="body1">{addressInfo.postalCode}</Typography>
                    </Grid>
                </Grid> */}
            </TabPanel>
        </Grid>
    );
};

